import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import moment from 'moment';

type PlanningPageState = {
  startDate: string,
  timeFrame: number,
};

const now = moment().startOf('day').weekday(1);

const initialState: PlanningPageState = {
  startDate: now.toISOString(), // Monday of current week
  timeFrame: 7,
};

export const planningPageSlice = createSlice({
  name: 'planningPage',
  initialState,
  reducers: {
    startDateChanged: (state, action: PayloadAction<string>) => {
        state.startDate = action.payload;
    },
    timeFrameChanged: (state, action: PayloadAction<number>) => {
        if (action.payload > 1) {
          state.timeFrame = action.payload;
        }
    }
  },
});

export const { startDateChanged, timeFrameChanged } = planningPageSlice.actions;

export const selectPlanningPage = (state: RootState) => {
  const startDate = moment(state.planningPage.startDate);
  return {
    ...state.planningPage,
    startDate,
  };
};

export default planningPageSlice.reducer;
